<template>
  <div class="hrBlock" :class="{ '-or': or }">
    <hr />
    <span v-if="or" class="hrBlock_or">OR</span>
  </div>
</template>

<script lang="ts">
export default {
  name: 'HrBlock',

  props: {
    or: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'src/styles/abstracts/mixins';
@use 'src/styles/abstracts/variables' as var;

.hrBlock {
  margin-top: 40px;
  margin-bottom: 40px;

  hr {
    border: none;
    border-top: 1px solid var.$color-border-gray;
  }

  &.-or {
    margin-top: 50px;
    margin-bottom: 50px;
    position: relative;

    @include mixins.media() {
      margin-top: 60px;
      margin-bottom: 55px;
    }
  }

  &_or {
    position: absolute;
    width: 50px;
    height: 50px;
    border-radius: 50%;
    background-color: #fff;
    border: 1px solid var.$color-border-gray;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1.3rem;
    font-weight: 700;
    left: 50%;
    margin-top: -25px;
    margin-left: -25px;
  }
}
</style>
